module.exports = __webpack_public_path__ + "img/comp.39bb0545.png";